import styled from 'styled-components';
import { common } from 'themes/default';

export const PassengerSection = styled.section`
  width: 100%;
  margin: 24px 0;
`;

export const PassengerPanel = styled.div`
  padding: 16px;
  border: 1px solid ${common.tabs.baseBorder};
  border-top: 0;
  border-radius: 0 0 4px 4px;
  > div {
    margin: 0;
  }
`;

export const Page = styled.main`
  box-sizing: border-box;
  width: 100%;
  padding: 24px;
  max-width: 1400px;
  margin: auto;
`;

export const Fields = styled.div`
  display: grid;
  grid-template-columns: repeat(${({ $columns = 4 }) => $columns}, minmax(0, 1fr));
  gap: 16px;
  margin: 16px 0;
  label {
    min-width: 0;
    display: flex;
    flex-direction: column;
    gap: 6px;
  }
  input,
  select {
    box-sizing: border-box;
    min-width: 0;
    width: 100%;
    height: 40px;
    padding: 8px;
    border: 1px solid #666;
    border-radius: 4px;
  }
  input[type='checkbox'] {
    width: 18px;
    height: 18px;
  }
  @media (max-width: 700px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  @media (max-width: 420px) {
    grid-template-columns: minmax(0, 1fr);
  }
`;

export const RouteFields = styled(Fields)`
  grid-template-columns: minmax(0, 1fr) repeat(2, minmax(0, 2fr));
  @media (max-width: 700px) {
    grid-template-columns: minmax(0, 1fr);
  }
`;

export const SearchAction = styled.div`
  grid-column: 3 / -1;
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
  @media (max-width: 700px) {
    grid-column: 1 / -1;
  }
`;

export const Calendars = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 24px;
  margin: 24px 0;
`;

export const CalendarPanel = styled.section`
  container-type: inline-size;
  border: 1px solid #375f63;
  border-radius: 8px;
  overflow: hidden;
  header {
    background: #375f63;
    color: white;
    padding: 16px;
    display: flex;
    justify-content: space-between;
  }
  h2 {
    font-size: 18px;
    text-align: center;
  }
`;

export const CalendarGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(7, minmax(0, 1fr));
  gap: 4px;
  padding: 12px;
  text-align: center;
`;

export const Day = styled.button`
  box-sizing: border-box;
  min-width: 0;
  width: 100%;
  padding: 8px 2px;
  min-height: 72px;
  border: 2px solid ${({ $selected }) => ($selected ? '#375f63' : 'transparent')};
  border-radius: 5px;
  background: ${({ $selected }) => ($selected ? '#e1eeee' : 'white')};
  cursor: pointer;
  color: #222;
  &:disabled {
    cursor: default;
    color: #666;
  }
  &:focus-visible {
    outline: 2px solid #375f63;
  }
  > span {
    display: block;
    margin-top: 8px;
    font-size: 14px;
    line-height: 1.3;
    font-weight: bold;
  }
  > span span {
    display: inline;
    margin: 0;
  }
  @container (max-width: 400px) {
    > span {
      font-size: 10px;
    }
  }
`;

export const StyledFarePrice = styled.span`
  width: fit-content;
  max-width: 100%;
  margin-left: auto;
  margin-right: auto;
  padding: 2px;
  box-sizing: border-box;
  border-radius: 4px;
  white-space: nowrap;
  && span {
    color: inherit;
    background-color: transparent;
  }
`;
